module.exports = __webpack_public_path__ + "img/3.808de7d4.jpg";